export interface VerticalDividerProps {
  className?: string;
}

export default function VerticalDivider({ className }: VerticalDividerProps) {
  return <div className={`h-4 w-[1px] bg-divider ${className}`}></div>;
}
